import { useGetRecipesQuery } from '@/features/recipes/api';
import { useGetIngredientsQuery } from '@/features/ingredients/api';
import { useGetEventsQuery } from '@/features/events/api';
import { useGetMealPlanEntriesQuery } from '../api';
import { MobileMealPlanView } from './MobileMealPlanView';
import { DesktopMealPlanView } from './DesktopMealPlanView';
import { useMediaQuery, useTheme } from '@mui/material';

export function WeeklyCalendar({ householdId, currentWeek, selectedDate, onDateChange, weekStartDay = 1 }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMobile = !isSmallScreen;

  const mealPlanEntries = useGetMealPlanEntriesQuery({ householdId });
  const recipes = useGetRecipesQuery({ householdId });
  const ingredientsQuery = useGetIngredientsQuery({});
  const eventsQuery = useGetEventsQuery({ householdId });
  const mealPlanEntriesData = mealPlanEntries?.data?.data || [];
  const ingredients = ingredientsQuery?.data?.data || [];
  const events = eventsQuery?.data?.data || [];

  return (isMobile) ?
    <MobileMealPlanView
      householdId={householdId}
      currentWeek={currentWeek}
      selectedDate={selectedDate}
      onDateChange={onDateChange}
      weekStartDay={weekStartDay}
      mealPlanEntries={mealPlanEntriesData}
      recipes={recipes}
      ingredients={ingredients}
      events={events}
    /> :
    <DesktopMealPlanView
      householdId={householdId}
      currentWeek={currentWeek}
      onDateChange={onDateChange}
      weekStartDay={weekStartDay}
      mealPlanEntries={mealPlanEntries}
      recipes={recipes}
      ingredients={ingredients}
      events={events}
    />;
}
